import type { Slide } from '@/entities/deck'
import type { DeepReadonly } from 'vue'

export function useSetAnnotationsFromPanZoom({
  panZoomTransform,
  slide,
  updateSiteAnnotations,
}: {
  panZoomTransform: Ref<PanZoomTransform>
  slide: DeepReadonly<Ref<Slide>>
  updateSiteAnnotations: ({ zoom, pan }: { zoom: number; pan: Point }) => void
}) {
  // Set pan/zoom when navigating to/from an image or PDF slide
  // Note: this does NOT include PDF or image hotspots – site slide handles
  // those cases internally
  watch([panZoomTransform, () => slide.value?.type], ([pzt, type], [oldPzt, oldType]) => {
    if ('IP'.includes(type) && pzt?.dimensions) {
      const { scale, center, containedSize } = pzt.dimensions
      updateSiteAnnotations({
        zoom: scale,
        // normalize pan coords to (0,0) with range of (-1,1) at image bounds (not container bounds) to match annotations layer
        pan: { x: (center.x / containedSize.width) * 2 - 1, y: (center.y / containedSize.height) * 2 - 1 },
      })
    } else if ('IP'.includes(oldType) && !'IP'.includes(type)) {
      updateSiteAnnotations({ zoom: 1, pan: { x: 0, y: 0 } })
    }
  })
}
